import { Box } from '@mui/material';
import { ClientListProps } from 'model/client.model';
import { LayoutType } from 'model/deals.model';
import ClientColumnGrid from './ClientColumnGrid';
import ClientRowGrid from './ClientRowGrid';

const ClientsList = ({ layout, category, data, loading }: ClientListProps) => {
  const Content = layout === LayoutType.KANBAN ? ClientColumnGrid : ClientRowGrid;

  return (
    <Box>
      <Content clients={data} category={category} loading={loading} />
    </Box>
  );
};

export default ClientsList;
